import { api } from '@/api/api';

export const segmentExports = {
  namespaced: true,
  state: {
    fetchingList: false,
    list: [],
    mappings: [],
  },
  getters: {
    empty(state) {
      return state.list.length === 0;
    },
  },
  mutations: {
    setFetching(state, fetching) {
      state.fetchingList = fetching;
    },
    setExports(state, exportList) {
      state.list = exportList;
    },
    addExport(state, exportItem) {
      state.list.push(exportItem);
    },
    setMappings(state, mappings) {
      state.mappings = mappings;
    },
    addMapping(state, mapping) {
      state.mappings.push(mapping);
    },
  },
  actions: {
    async fetchExports({ rootState, commit }) {
      if (rootState.company.currentId === -1) {
        return;
      }
      commit('setFetching', true);
      const [exportResponse, mappingResponse] = await Promise.all([
        api.get(
          `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/exports/`
        ),
        api.get(
          `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/mappings/`
        ),
      ]);
      commit(
        'setExports',
        exportResponse.data.map((exportItem) => ({
          ...exportItem,
          editing: false,
        }))
      );
      commit('setMappings', mappingResponse.data);
      commit('setFetching', false);
    },
    async updateExport(
      { rootState, state, commit, dispatch },
      { exportItem, mapping }
    ) {
      const possibleMapping = state.mappings.find(
        (m) => m.export_target.id === exportItem.export_target
      );
      if (!possibleMapping) {
        await dispatch('addMapping', {
          exportTargetId: exportItem.export_target,
          mapping,
        });
      }
      await Promise.all([
        api.patch(
          `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/exports/${exportItem.id}/`,
          exportItem
        ),
        possibleMapping &&
          dispatch('updateMapping', { id: possibleMapping.id, mapping }),
      ]);
      commit(
        'setExports',
        state.list.map((e) => {
          if (e.id === exportItem.id) {
            return exportItem;
          }
          return e;
        })
      );
    },
    async addExport({ rootState, commit, dispatch }, { exportItem, mapping }) {
      const exportResponse = await api.post(
        `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/exports/`,
        exportItem
      );
      await dispatch('addMapping', {
        exportTargetId: exportResponse.data.export_target.id,
        mapping,
      });

      commit('addExport', {
        ...exportResponse.data,
        editing: false,
      });
    },
    async updateMapping({ rootState, state, commit }, { id, mapping }) {
      await api.patch(
        `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/mappings/${id}/`,
        {
          mapping,
        }
      ),
        commit(
          'setMappings',
          state.mappings.map((m) => {
            if (m.id === id) {
              return {
                ...m,
                mapping,
              };
            }
            return m;
          })
        );
    },
    async addMapping({ rootState, commit }, { exportTargetId, mapping }) {
      const mappingResponse = await api.post(
        `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/mappings/`,
        {
          export_target: exportTargetId,
          mapping,
        }
      );
      commit('addMapping', mappingResponse.data);
    },
  },
};
